import React, {PureComponent} from 'react';
import {IReducerState} from '../../../../states/renditionStates';
import {connect} from 'react-redux';
import {RenditionLoadable} from "../../../../utils/general/LoadableRelated";
import MustReadContent from "./mustReadContent";
import KeyDataChangeContent from "./keyDataChangeContent";
import GlobalMarketDataContent from "./globalMarketDataContent";
import EconomicCalendarContent from "./economicCalendarContent";
import EventCalendarContent from "./eventCalendarContent";
import {switchPage} from "../../../../utils/api/pageControl";
import * as HTML_RENDITION from '../../../../utils/general/general';
import {enterKeyPressed} from '../../../../utils/general/enterKey';
import $ from "jquery";
import _ from 'lodash';
import {RSCH_HTML_TRACKING_CONFIG} from '../../../../readership/trackingConfig';

const ModalPopup = RenditionLoadable({
    loader: () => import('../../../../modalrelated/modalPopup'),
}, "modalPopup", Date.now());

const NormalScreenPopup = RenditionLoadable({
    loader: () => import('../../../../modalrelated/normalScreenPopup'),
}, "NormalScreenPopup", Date.now());

// Improtant!!! in future you should separate this component like financialsBlock
interface IPointFinancialsBlockProps {
    source?: any;
    docHeaderSectionJson: any;
    initialData: any;
}

class PointFinancialsBlock extends PureComponent<IPointFinancialsBlockProps, any> {

    constructor(props: IPointFinancialsBlockProps) {
        super(props);
        this.state = {
            modalStatus: false,
            sections: []
        };
    }

    public render() {
        return this.state.modalStatus ? this.state.sections : this.renderSections();
    }

    public componentDidMount() {
        const self = this;
        $(document).on('click', function (e: any) {
            const id = e.target.id;
            if (id === "modalClose") {
                self.setState({
                    modalStatus: false,
                });
                $('.triggered_popup_flag').focus().removeClass('triggered_popup_flag');
            }
        });
    }

    public openModal(e: any) {
        if (e.target.id === "modalClose" || e.target.className === 'bb_scrollToLink') {
            this.setState({
                modalStatus: false,
            });
        } else if (this.state.modalStatus === false) {
            this.setState({
                modalStatus: true,
            });
        }
    }

    private getEconomicCalendarContentDetachURL() {
        const title = this.props.docHeaderSectionJson.i18n.economic + " " + this.props.docHeaderSectionJson.i18n.calendar;
        window.HTML_RENDITION.openDetachURL = HTML_RENDITION.getDetachUrl('pointEconomicCalendar', title, 0);
        return window.HTML_RENDITION.openDetachURL;
    }

    private getEventCalendarContentDetachURL() {
        const title = this.props.docHeaderSectionJson.i18n.event + " " + this.props.docHeaderSectionJson.i18n.calendar;
        window.HTML_RENDITION.openDetachURL = HTML_RENDITION.getDetachUrl('pointEventCalendar', title, 0);
        return window.HTML_RENDITION.openDetachURL;
    }

    private renderSections() {
        const { initialData, docHeaderSectionJson } = this.props;
        const shouldShowEconomicCalendar = docHeaderSectionJson.metadata.EconomicCalendar;
        const shouldShowCorporateCalendar = docHeaderSectionJson.metadata.CorporateCalendar;
        const hasReportingCalendarEntitlement = initialData.isEntitled("REPORTING_CALENDAR");
        const corporateCalendarForecastSectionElements = [];
        const mustReadForecastSection = docHeaderSectionJson.metadata.showMustRead && (
            <div tabIndex={0} id="mustReadForecast"
                onClick={(e) => this.onClickSection("mustReadForecast", e)}
                onKeyPress={(e) => enterKeyPressed(e, this.onClickSection.bind(this, "mustReadForecast", e))}>
                <div className="financials">
                    <span className="icon-must-read-forecast icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.mustReadForecast}></span>
                    <a tabIndex={0} role="button" aria-label={docHeaderSectionJson.i18n.mustReadForecast} id="financials-must-read-forecast" className="x-rsch-hyperlink">
                        {docHeaderSectionJson.i18n.mustReadForecast}
                    </a>
                </div>
            </div>);
        const keyDataChangeSection = docHeaderSectionJson.metadata.KeyDataChanges &&
            (<div tabIndex={0} id="keyDataChanges" onClick={(e) => this.onClickSection("keyDataChanges", e)}
                  onKeyPress={(e) => enterKeyPressed(e, this.onClickSection.bind(this, "keyDataChanges", e))}>
                <div className="financials">
                    <span className="icon-key-data-forecast icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.keyDataChanges} />
                    <a tabIndex={0} id="financials-key-data-forecast" role="button"
                       aria-label={docHeaderSectionJson.i18n.keyDataChanges}
                       className="x-rsch-hyperlink">{docHeaderSectionJson.i18n.keyDataChanges}</a>
                </div>
            </div>);
        if (hasReportingCalendarEntitlement) {
            corporateCalendarForecastSectionElements.push(<a tabIndex={0} id="financials-reporting-calendar" role="button"
                                                             aria-label={docHeaderSectionJson.i18n.corporate}
                                                             onClick={() => switchPage("reportingCalendarPage")}
                                                             onKeyPress={(e) => enterKeyPressed(e, switchPage.bind(this, "reportingCalendarPage"))}
                                                             className={"x-rsch-hyperlink"}>{docHeaderSectionJson.i18n.corporate}</a>
            );
        }
        // Economic calendar
        if (shouldShowEconomicCalendar) {
            corporateCalendarForecastSectionElements.push(<span> | </span>);
            corporateCalendarForecastSectionElements.push(
            <React.Fragment>
                <span className="point-financials-reporting-calendar" onClick={(e) => this.onClickSection("reportingCalendarEconomic", e)}
                      onKeyPress={(e) => enterKeyPressed(e, this.onClickSection.bind(this, "reportingCalendarEconomic", e))}>
                    <a tabIndex={0} id="financials-data-calendar" className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.economic} role="button">{docHeaderSectionJson.i18n.economic}</a>
                </span>
            </React.Fragment>);
        }
        // Event calendar
        if (shouldShowCorporateCalendar) {
            corporateCalendarForecastSectionElements.push(<span> | </span>);
            corporateCalendarForecastSectionElements.push(
            <React.Fragment>
                <span className="point-financials-reporting-calendar"
                      onKeyPress={(e) => enterKeyPressed(e, this.onClickSection.bind(this, "reportingCalendarEvent", e))}
                      onClick={(e) => this.onClickSection("reportingCalendarEvent", e)}>
                    <a tabIndex={0} id="financials-corporate" className="x-rsch-hyperlink" aria-label={docHeaderSectionJson.i18n.event} role="button">{docHeaderSectionJson.i18n.event}</a>
                </span>
            </React.Fragment>);
        }
        {/*  const corporateCalendarForecastSection = (<div id="corporateCalenderForecast">
            <div className="financials">
                <span tabIndex={0} className="icon-corporate-calender-forecast icon-sprite"
                        onKeyPress={(e) => enterKeyPressed(e, switchPage.bind(this, "reportingCalendarPage"))}
                        onClick={() => switchPage("reportingCalendarPage")}
                        role="img" aria-label={docHeaderSectionJson.i18n.calendar}
                ></span>
                <span tabIndex={0} className="calendarText"
                        onKeyPress={(e) => enterKeyPressed(e, switchPage.bind(this, "reportingCalendarPage"))}
                        onClick={() => switchPage("reportingCalendarPage")}>{docHeaderSectionJson.i18n.calendar}:</span>
                {corporateCalendarForecastSectionElements}
            </div>
        </div>);
        */ }
        const globalMarketDataSection = docHeaderSectionJson.metadata.GlobalMarketData &&
            (<div tabIndex={0} id="globalMarketData"
                    onKeyPress={(e) => enterKeyPressed(e, this.onClickSection.bind(this, "globalMarketData", e))}
                    onClick={(e) => this.onClickSection("globalMarketData", e)}>
                <div className="financials">
                    <span className="icon-global-market icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.globalMarketData}></span>
                    <a tabIndex={0} id="financials-global-market-data" role="button"
                    aria-label={docHeaderSectionJson.i18n.globalMarketData}
                    className="x-rsch-hyperlink">{docHeaderSectionJson.i18n.globalMarketData}</a>
                </div>
            </div>);
        const conferenceForecastSection = (
            <div tabIndex={0} id="conferencesForecast"
                    onKeyPress={(e) => enterKeyPressed(e, this.onClickSection.bind(this, "conferencesForecast", e))}
                    onClick={(e) => this.onClickSection("conferencesForecast", e)}>
                <div className="financials hide">
                    <span className="icon-conferences-forecast icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.conferencesForecast}></span>
                    <a tabIndex={0} id="financials-conferences-forecast" role="button"
                    aria-label={docHeaderSectionJson.i18n.conferencesForecast}
                    className="x-rsch-hyperlink">{docHeaderSectionJson.i18n.conferencesForecast}</a>
                </div>
            </div>);
        return [conferenceForecastSection];
    }

    private onClickSection(eid: string, e?: any) {
        const {docHeaderSectionJson} = this.props;
        const sections: any = this.renderSections();
        if (!_.isEmpty(e)) {
            e.target.className += " triggered_popup_flag";
        }
        if (eid === "mustReadForecast") {
            RSCH_HTML_TRACKING_CONFIG.trackMustReadForecast();
            const modalMustReadForecastSection = (
                <MustReadContent getTarget={e.currentTarget} />
            );
            sections.splice(1, 0, modalMustReadForecastSection);
        } else if (eid === "keyDataChanges") {
            RSCH_HTML_TRACKING_CONFIG.trackKeydataChanges();
            const modalKeyDataChange = (
                <ModalPopup>
                    <NormalScreenPopup
                        titleSource={docHeaderSectionJson.i18n.keyDataChanges}
                        modalWindowStyle={{ display: 'flex', flexDirection: 'column', width: '1000px', maxWidth: '1000px', height: "650px", maxHeight: '650px'}}
                        bodySource={<KeyDataChangeContent/>}
                        openDetachURL={this.getEmbeddedPointKeyDataChangesDetachURL()}
                        modalClass='key-data-changes-modal'
                    />
                </ModalPopup>);
            sections.splice(2, 0, modalKeyDataChange);
        } else if (eid === "globalMarketData") {
            RSCH_HTML_TRACKING_CONFIG.trackGlobalMarketData();
            const modalGlobalMarketData = (
                <ModalPopup>
                    <NormalScreenPopup
                        titleSource={docHeaderSectionJson.i18n.globalMarketData}
                        bodySource={<GlobalMarketDataContent/>}
                        openDetachURL={this.getEmbeddedGloablMarketDataDetachURL()}
                        modalWindowStyle={{ display: 'flex', flexDirection: 'column', width: '1000px', maxWidth: '1000px', height: "650px", maxHeight: '650px'}}
                        modalClass='global-market-data-modal'
                    />
                </ModalPopup>);
            sections.splice(4, 0, modalGlobalMarketData);
        } else if (eid === "reportingCalendarEvent") {
            RSCH_HTML_TRACKING_CONFIG.trackReportingCalendar();
            const reportingCalendarEventData = (
                <ModalPopup>
                    <NormalScreenPopup
                        titleSource={docHeaderSectionJson.i18n.event + " " + docHeaderSectionJson.i18n.calendar}
                        bodySource={<EventCalendarContent />}
                        modalWindowStyle={{ width: '1000px', maxWidth: '1000px', height: '500px', maxHeight: '500px' }}
                        openDetachURL={this.getEventCalendarContentDetachURL()}
                        modalClass='point-event-calendar-modal'
                    />
                </ModalPopup>);
            sections.splice(3, 0, reportingCalendarEventData);
        } else if (eid === "reportingCalendarEconomic") {
            RSCH_HTML_TRACKING_CONFIG.trackEconomicsdatacalendar();
            const reportingCalendarEconomicData = (
                <ModalPopup>
                    <NormalScreenPopup
                        titleSource={docHeaderSectionJson.i18n.economic + " " + docHeaderSectionJson.i18n.calendar}
                        bodySource={<EconomicCalendarContent />}
                        modalWindowStyle={{ width: '1000px', maxWidth: '1000px', height: '500px', maxHeight: '500px' }}
                        openDetachURL={this.getEconomicCalendarContentDetachURL()}
                        modalClass='point-economic-calendar-modal'
                    />
                </ModalPopup>);
            sections.splice(3, 0, reportingCalendarEconomicData);
        }

        this.setState({
            modalStatus: true,
            sections
        });
    }

    private getEmbeddedGloablMarketDataDetachURL() {
        window.HTML_RENDITION.openDetachURL = HTML_RENDITION.getDetachUrl('gloablMarketData', this.props.docHeaderSectionJson.i18n.globalMarketData, 0);
        return window.HTML_RENDITION.openDetachURL;
    }

    private getEmbeddedPointKeyDataChangesDetachURL() {
        window.HTML_RENDITION.openDetachURL = HTML_RENDITION.getDetachUrl('pointKeyDataChanges', this.props.docHeaderSectionJson.i18n.keyDataChanges, 0);
        return window.HTML_RENDITION.openDetachURL;
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
    };
};

export default connect(mapStateToProps)(PointFinancialsBlock);
